<template>
  <div>
    <div
      class="mdgridviewpage-bg mainWrap-bg applicationListPage indicatorPage"
    >
      <!-- <HeaderNew></HeaderNew> -->
      <div class="container-fluid maindivWrap">
        <div class="row mt-4">
          <div class="col-sm-12">
            <div class="wizardCard mb-4">
              <div class="card shadow-sm">
              <div class="card-header text-decoration-none">Select Your Module</div>
              <div class="collapse show">
                <div class="card-body p-40px">
                  <div class="row m-t-20px appconfing-selectmodulecontainer">
                    <div class="col-lg-3 text-center">
                      
                      <p>Ministerial Dashboard</p>
                      <div class="config-icon-container bg-light-red">
                        <img
                          src="../assets/img/home/min-dashboard-icon-white.png"
                          class="img img-fluid"
                        />
                      </div>
                      <div class="form-group m-t-20px">
                        <div class="form-check">
                          <div class="pure-checkbox">
                            <input
                              type="checkbox"
                              id="ministral-chk"
                              value="ministerial"
                              v-model="frmModel.modules"
                              disabled
                            />
                            <label for="ministral-chk"></label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 text-center">
                      
                      <p>Analytical Dashboard</p>
                      <div class="config-icon-container bg-light-green">
                        <img
                          src="../assets/img/home/ana-dashboard-icon-white.png"
                          class="img img-fluid"
                        />
                      </div>
                      <div class="form-group m-t-20px">
                        <div class="form-check">
                          <div class="pure-checkbox">
                            <input
                              type="checkbox"
                              id="analytical-chk"
                              value="analytical"
                              v-model="frmModel.modules"
                              disabled
                            />
                            <label for="analytical-chk"></label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 text-center">
                      <p>Interactive Analytics</p>
                      <div class="config-icon-container bg-light-yellow">
                        <img src="../assets/img/home/int-icon-white.png" class="img img-fluid" />
                      </div>
                      <div class="form-group m-t-20px">
                        <div class="form-check">
                          <div class="pure-checkbox">
                            <input
                              type="checkbox"
                              id="interactive-chk"
                              value="interactive"
                              v-model="frmModel.modules"
                              disabled
                            />
                            <label for="interactive-chk"></label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 text-center">
                      <p>Saved Favorites</p>
                      <div class="config-icon-container bg-light-purple">
                        <img src="../assets/img/home/int-icon-white.png" class="img img-fluid" />
                      </div>
                      <div class="form-group m-t-20px">
                        <div class="form-check">
                          <div class="pure-checkbox">
                            <input
                              type="checkbox"
                              id="interactive-chk"
                              value="interactive"
                              v-model="frmModel.modules"
                              disabled
                            />
                            <label for="interactive-chk"></label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      
                      class="col-lg-3 text-center"
                    >
                      <p>Data Quality Review</p>
                      <div class="config-icon-container bg-light-blue">
                        <img
                          src="../assets/img/home/dataquality-icon-white.png"
                          class="img img-fluid"
                        />
                      </div>
                      <div class="form-group m-t-20px">
                        <div class="form-check">
                          <div class="pure-checkbox">
                            <input
                              type="checkbox"
                              id="dqr-chk"
                              value="dataqualityreview"
                              v-model="frmModel.modules"
                              disabled
                            />
                            <label for="dqr-chk"></label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>

           

          <div class="col-sm-12">
            <div class="bottomSubmitbtn float-right mb-4">
              <!-- <button class="btn btn-newprimary">
                <i
                  class="fa fa-angle-double-left pr-2 text-white"
                  aria-hidden="true"
                ></i>
                Back
                
              </button> -->
              
              <button class="btn btn-newprimary">
                Save
                <!-- <i
                  class="fa fa-angle-double-right pl-2 text-white"
                  aria-hidden="true"
                ></i> -->
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <training-footer></training-footer> -->
  </div>
</template>
<script>
import HeaderNew from "../components/layout/HeaderNew";
import trainingFooter from "../components/trainingFooter";
import ApiServices from "../service/ApiServices";
import swal from "sweetalert2";
window.Swal = swal;

export default {
  components: {
    HeaderNew,
    trainingFooter,
  },
  data() {
    return {
      showIndForm: false,
      userProfile: "",
      baseUrl: "http://localhost:8080/dhis/",
      dashboardUrl: "api/apps/Avenir-Generic/index.html#/",
      options: [
        { value: null, text: "Please select an option", disabled: true },
        { value: "5", text: "5" },
        { value: "25", text: "25" },
        { value: "50", text: "50" },
        { value: "100", text: "100" },
      ],
      perPage: 10,
      serachoptionslist: "",
      currentPage: 1,
      allAppsList: [],
      allIndList: [],
      searchName: "",
      denomSearchName: "",
      isView: "list",
      allAppsListLen: 0,
      dataElementList: [],
      denomdataElemenList: [],
      indicatorTypes: [],
      indicatorType: "",
      expressionBuilder: "",
      serachoptionslist1: "",
      expressionBuilderHidden: "",
      denomExpressionBuilder: "",
      expressionbuilderstatuscheck: false,
      denomexpressionbuilderstatuscheck: false,
      //  indicatorTypeList:[],
      denomExpressionBuilderHidden: "",
      frmModel: {
        denominatorDescription: "",
        numeratorDescription: "",
        numerator: "",
        denominator: "",
        name: "",
        shortName: "",
        indicatorType: {},
        legendSets: [],
      },
    };
  },
  computed: {
    indicatorTypeList: function () {
      let typeArr = this.indicatorTypes;

      var arr = [];
      var obj = { value: "", text: "Select Indicator Type" };
      arr.push(obj);
      typeArr.forEach((type, ind) => {
        var obj = { value: "", text: "" };
        obj.value = type.id;
        obj.text = type.displayName;
        arr.push(obj);
      });
      // console.log(arr);
      return arr;
    },
    allIndList1() {
      let filteredInd = this.allIndList.filter(
        (a) =>
          (a.displayName &&
            a.displayName
              .toLowerCase()
              .includes(this.searchName.toLowerCase())) ||
          // (a.createdBy &&
          //   a.createdBy
          //     .toLowerCase()
          //     .includes(this.searchName.toLowerCase())) ||
          (a.lastUpdated &&
            a.lastUpdated.toLowerCase().includes(this.searchName.toLowerCase()))
      );
      this.allIndLen = filteredInd.length;
      // console.log(filteredInd);
      return filteredInd.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    // appsList() {
    //   let filteredApps = this.allAppsList.filter(
    //     (a) =>
    //       (a.appName &&
    //         a.appName.toLowerCase().includes(this.searchName.toLowerCase())) ||
    //       (a.createdBy &&
    //         a.createdBy
    //           .toLowerCase()
    //           .includes(this.searchName.toLowerCase())) ||
    //       (a.updatedBy &&
    //         a.updatedBy.toLowerCase().includes(this.searchName.toLowerCase()))
    //   );
    //   // console.log("filteredApps",filteredApps)
    //   this.allAppsListLen = filteredApps.length;
    //   return filteredApps.slice(
    //     (this.currentPage - 1) * this.perPage,
    //     this.currentPage * this.perPage
    //   );
    // },
    rows() {
      return this.allAppsList.length;
    },
  },
  watch: {
    expressionBuilderHidden(newVal) {
      console.log("Call api", newVal);
      if (newVal != "") {
        ApiServices.RestPostCall(
          "api/indicators/expression/description",
          newVal,
          "text/plain"
        ).then((res) => {
          console.log(res);
          if (res.status == "OK") {
            this.expressionbuilderstatuscheck = true;
            this.expressionBuilder = res.description;
          } else {
            this.expressionbuilderstatuscheck = false;
            this.expressionBuilder = "";
          }
        });
      } else {
        this.expressionBuilder = "";
        this.expressionbuilderstatuscheck = false;
      }
    },
    // denomExpressionBuilder(newv,oldval) {
    //   if (newv == "") this.denomExpressionBuilderHidden = newv;
    // },
    denomExpressionBuilderHidden(newVal) {
      console.log("Call denom api", newVal);
      if (newVal != "") {
        ApiServices.RestPostCall(
          "api/indicators/expression/description",
          newVal,
          "text/plain"
        ).then((res) => {
          // console.log(res);
          if (res.status == "OK") {
            this.denomexpressionbuilderstatuscheck = true;
            this.denomExpressionBuilder = res.description;
          } else {
            this.denomexpressionbuilderstatuscheck = false;
            this.denomExpressionBuilder = "";
          }
        });
      } else {
        this.denomExpressionBuilder = "";
        this.denomexpressionbuilderstatuscheck = false;
      }
    },

    serachoptionslist(newavl) {
      console.log(newavl);
      ApiServices.RestGetCall(
        "api/29/dataElementOperands?filter=dataElement.domainType:eq:AGGREGATE&filter=name:ilike:" +
          newavl +
          "&fields=id%2CdisplayName&totals=true",
        {}
      ).then((res) => {
        console.log(res);
        if (res.dataElementOperands != undefined)
          this.dataElementList = res.dataElementOperands;
      });
    },
    serachoptionslist1(newval) {
      console.log(newval);
      ApiServices.RestGetCall(
        "api/29/dataElementOperands?filter=dataElement.domainType:eq:AGGREGATE&filter=name:ilike:" +
          newval +
          "&fields=id%2CdisplayName&totals=true",
        {}
      ).then((res) => {
        console.log(res);
        if (res.dataElementOperands != undefined)
          this.denomdataElemenList = res.dataElementOperands;
      });
    },
  },
  methods: {
    resetForm() {
      this.showIndForm = false;
      this.frmModel = {
        denominatorDescription: "",
        numeratorDescription: "",
        numerator: "",
        denominator: "",
        name: "",
        shortName: "",
        indicatorType: {},
        legendSets: [],
      };
      this.expressionBuilderHidden = "";
      this.denomExpressionBuilderHidden = "";
      this.expressionBuilder = "";
      this.denomExpressionBuilder = "";
      this.indicatorType = "";
    },
    showForm() {
      this.showIndForm = true;
      this.frmModel = {
        denominatorDescription: "",
        numeratorDescription: "",
        numerator: "",
        denominator: "",
        name: "",
        shortName: "",
        indicatorType: {},
        legendSets: [],
      };
      this.expressionBuilderHidden = "";
      this.denomExpressionBuilderHidden = "";
      this.expressionBuilder = "";
      this.denomExpressionBuilder = "";
      this.indicatorType = "";
    },
    deleteind(id) {
      Swal.fire({
        text: "Are you sure?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes",
        cancelButtonColor: "#d33",
      }).then((result) => {
        console.log(result);
        if (result.value) {
          ApiServices.RestDeleteCall("api/indicators/" + id).then((res) => {
            console.log(res);
            if (res.status == "OK") {
              alert("Indicator deleted succesfully");
            }
          });
        }
      });
    },
    editind(id) {
      this.showIndForm = true;
      ApiServices.RestGetCall(
        "api/indicators/" +
          id +
          "?fields=%3Aall%2CattributeValues%5B%3Aall%2Cattribute%5Bid%2Cname%2CdisplayName%5D%5D"
      ).then((res) => {
        console.log(res);
        this.frmModel = res;
        console.log(this.frmModel);
        this.expressionBuilderHidden = this.frmModel.numerator;
        this.denomExpressionBuilderHidden = this.frmModel.denominator;
        // this.expressionBuilder = this.getEquestion(this.frmModel.numerator);
        // this.denomExpressionBuilder = this.getEquestion(
        //   this.frmModel.denominator
        // );
        this.indicatorType = this.frmModel.indicatorType.id;
      });
      ApiServices.RestGetCall(
        "api/indicatorTypes?fields=id%2CdisplayName%2Cname&paging=false"
      ).then((res) => {
        console.log(res);
        this.indicatorTypes = res.indicatorTypes;
      });
    },
    getEquestion(expression) {
      var newexp = expression;
      this.dataElementList.forEach((obj) => {
        if (expression.search("#{" + obj.id + "}") != -1) {
          newexp = newexp.replace("#{" + obj.id + "}", obj.displayName);
        }
      });
      return newexp;
    },

    updateInd() {
      this.frmModel.numerator = this.expressionBuilderHidden;
      this.frmModel.denominator = this.denomExpressionBuilderHidden;
      var formData = this.frmModel;
      console.log(formData);
      ApiServices.RestPutCall(
        "/api/indicators/" + formData.id + "?mergeMode=REPLACE",
        formData
      ).then((res) => {
        console.log(res);
        if (res.httpStatusCode == 200) {
          this.frmModel = {
            denominatorDescription: "",
            numeratorDescription: "",
            numerator: "",
            denominator: "",
            name: "",
            shortName: "",
            indicatorType: {},
            legendSets: [],
          };
          this.expressionBuilderHidden = "";
          this.denomExpressionBuilderHidden = "";
          this.expressionBuilder = "";
          this.denomExpressionBuilder = "";
          this.indicatorType = "";
          this.showIndForm = false;
          Swal.fire({
            text: "Indicator updated successfully",
            //  icon: 'warning',
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          }).then(function () {
            window.location = "#/indicatorAdd";
          });
        }
      });
    },
    submitInd() {
      this.frmModel.numerator = this.expressionBuilderHidden;
      this.frmModel.indicatorType = { id: this.indicatorType };
      this.frmModel.denominator = this.denomExpressionBuilderHidden;
      var formData = this.frmModel;
      ApiServices.RestPostCall("api/indicators", formData).then((res) => {
        console.log(res);
        if (res.httpStatusCode == 201) {
          this.frmModel = {
            denominatorDescription: "",
            numeratorDescription: "",
            numerator: "",
            denominator: "",
            name: "",
            shortName: "",
            indicatorType: {},
            legendSets: [],
          };
          this.expressionBuilderHidden = "";
          this.denomExpressionBuilderHidden = "";
          this.expressionBuilder = "";
          this.denomExpressionBuilder = "";
          this.indicatorType = "";
          this.showIndForm = false;
          Swal.fire({
            text: "Indicator created successfully",
            icon: "warning",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          }).then(function () {
            window.location = "#/indicatorAdd";
          });
        } else {
          Swal.fire({
            text: "Something went wrong. Please try again",
            icon: "warning",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          }).then(function () {
            window.location = "#/indicatorAdd";
          });
        }
      });
    },
    addElem(elemId, elemName, typeSt = null) {
      this.expressionBuilder = this.expressionBuilder + elemName;
      if (typeSt == "DataElem") {
        this.expressionBuilderHidden =
          this.expressionBuilderHidden + "#{" + elemId + "}";
      } else {
        this.expressionBuilderHidden = this.expressionBuilderHidden + elemId;
      }
    },
    addElemDenom(elemId, elemName, typeSt = null) {
      this.denomExpressionBuilder = this.denomExpressionBuilder + elemName;
      if (typeSt == "DataElem") {
        this.denomExpressionBuilderHidden =
          this.denomExpressionBuilderHidden + "#{" + elemId + "}";
      } else {
        this.denomExpressionBuilderHidden =
          this.denomExpressionBuilderHidden + elemId;
      }
    },
    gotoApp(appId, appUserId) {
      window.open(
        `http://localhost:8080/#/?appId=${appId}&appUserId=${appUserId}`,
        "_blank"
      );
    },
    logout() {
      //dhis-web-commons-security/logout.action
      localStorage.removeItem("userProfile");
      localStorage.removeItem("loggedInUserId");
      ApiServices.RestGetCall(
        "dhis-web-commons-security/logout.action",
        {}
      ).then((res) => {
        console.log(res);
      });
      //window.open('http://intraavenir.duredemos.com/service/dhis-web-commons-security/logout.action', '_blank');
      this.$router.push("/");
    },
    getList() {
      ApiServices.RestGetCall(
        "api/dataElementOperands?filter=dataElement.domainType:eq:AGGREGATE&fields=id%2CdisplayName&totals=true",
        {}
      ).then((res) => {
        console.log(res);
        if (res.dataElementOperands != undefined)
          this.dataElementList = res.dataElementOperands;
        this.denomdataElemenList = res.dataElementOperands;
      });
      ApiServices.RestGetCall(
        "api/indicatorTypes?fields=id%2CdisplayName%2Cname&paging=false"
      ).then((res) => {
        console.log(res);
        this.indicatorTypes = res.indicatorTypes;
      });
    },
    getAllApps() {
      console.log(this.$root);
      this.$root.loading = true;
      ApiServices.getAllKeys()
        .then(async (response) => {
          console.log(response);
          let filteredApps = [];

          response.data.forEach((a) => {
            let keyName = a.split("_");
            if (a.includes("applicationModule") && keyName.includes("en")) {
              filteredApps.push(a);
            }
          });

          await ApiServices.RestGetCall(
            "/api/avenir/training/getTrainingApps"
          ).then((response) => {
            console.log("Training response", response.trainingApp);
            response.trainingApp.forEach((t) => {
              this.allAppsList.push(t);
            });
          });
          if (filteredApps.length) {
            filteredApps.forEach(async (f, i) => {
              let appResponse = await ApiServices.getSavedConfig(f);
              this.allAppsList.push(appResponse.data);
              if (this.allAppsList.length === filteredApps.length) {
                this.$root.loading = false;
                console.log("apps List", this.allAppsList);
              }
            });
          }
        })
        .catch((res) => (this.$root.loading = false));
    },
    getIndicatorList() {
      ApiServices.RestGetCall(
        "api/indicators?filter=name:ne:default&fields=name%2CnumeratorDescription%2CdenominatorDescription%2Cdenominator%2Cnumerator%2CdisplayName%2CshortName%2Cid%2ClastUpdated%2Ccreated%2CdisplayDescription%2Ccode%2CpublicAccess%2Caccess%2Chref%2Clevel%2CdisplayName%2CindicatorType%5BdisplayName%5D%2CpublicAccess%2ClastUpdated%2C&order=displayName%3AASC&paging=false"
      ).then((response) => {
        console.log(response);
        this.allIndList = response.indicators;
      });
    },
  },
  mounted() {
    this.userProfile = JSON.parse(localStorage.getItem("userProfile"));
    this.baseUrl = ApiServices.getBaseUrl();
    this.dashboardUrl = this.baseUrl + this.dashboardUrl;
    //this.getAllApps();
    this.getIndicatorList();
    this.getList();
  },
};
</script>
<style scoped lang="scss">
.mainWrap-bg {
  background-color: #f4f4f4 !important;
  background-image: none;
  /* background-size: cover;
  background-position: center; */
  min-height: 100vh;
  /* padding: 20px 40px; */
  padding: 10px 20px;
}
.maindivWrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.form-control {
  background-color: transparent !important;
}
.tableCard {
  .table {
    thead {
      tr {
        background: #2e3f53;
        th {
          color: #fff;
        }
      }
    }
  }
}
.addIndicatorTypebtn {
  position: relative;
  text-align: left;
  font-weight: 200 !important;
  border-radius: 2px !important;
  font-size: 0.875rem;
}
.addIndicatorTypebtn:hover {
  position: relative;
  text-align: left;
  font-weight: 200 !important;
  border-radius: 2px !important;
  font-size: 0.875rem;
}
.addIndicatorTypebtn::after {
  position: absolute;
  right: 15px;
  top: 15px;
}
.multiSelectOption option {
  font-size: 0.875rem;
  background: #f5f5f5;
  padding: 10px 12px;
  margin-bottom: 1%;
  white-space: initial;
  min-height: 2.5em;
}
.swipTextWrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.checkValid {
  text-align: left;
  width: 100%;
  position: relative;
  bottom: -57px;
  font-weight: 600;
}
textarea {
  width: 100%;
  height: 200px !important;
}
.has-search .form-control {
  padding-left: 2.375rem;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  // height: 2.375rem;
  // line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
}
.bg-light-purple {
  background-color: #3662a8 !important;
}
</style>
